import util from '@/util'

let chatInicializado = false
let dadosUsuarioAtuais = {}

const ehUsuarioAnonimo = (nome, email) => util.valorVazio(nome) || util.valorVazio(email)

const montarDadosUsuario = (nome = null, email = null, dataCriacao = null, idUsuario = null, idEscritorio = null, nomeEscritorio = null) => {
  if (ehUsuarioAnonimo(nome, email)) return {}

  const timestamp = dataCriacao ? Math.floor(new Date(dataCriacao).getTime() / 1000) : null
  const tenantUserId = idEscritorio && idUsuario ? `${idEscritorio}-${idUsuario}` : null
  const usuario = {
    name: nome,
    email: email,
    created_at: timestamp,
    user_id: tenantUserId,
    company: {
      id: idEscritorio,
      name: nomeEscritorio
    }
  }

  const limparDados = (obj) =>
    Object.fromEntries(
      Object.entries(obj)
        .filter(([_, v]) => v !== null)
        .map(([k, v]) => [k, v && typeof v === 'object' ? limparDados(v) : v])
    )

  return limparDados(usuario)
}

const dadosUsuarioSaoIguais = (dadosNovos, dadosAnteriores) => {
  return JSON.stringify(dadosNovos) === JSON.stringify(dadosAnteriores)
}

const removerCookiesIntercom = () => {
  const cookies = document.cookie.split(';')

  cookies.forEach(cookie => {
    const cookieName = cookie.trim().split('=')[0]
    if (cookieName.startsWith('intercom-')) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
    }
  })

  console.log('Todos os cookies Intercom removidos.')
}

const restaurarDadosDefault = () => {
  chatInicializado = false
  dadosUsuarioAtuais = {}
  removerCookiesIntercom()
}

const registrarInicializacaoIntercom = (dadosUsuario) => {
  const modo = ehUsuarioAnonimo(dadosUsuario.name, dadosUsuario.email) ? 'anonimamente' : ''
  console.log(`Chat do Intercom iniciado ${modo}`)
}

const iniciarChat = async (vueInstance, nome = null, email = null, dataCriacao = null, idUsuario = null, idEscritorio = null, nomeEscritorio = null) => {
  if (chatInicializado) {
    console.log('Chat do Intercom já inicializado')
    return
  }

  const dadosUsuario = montarDadosUsuario(nome, email, dataCriacao, idUsuario, idEscritorio, nomeEscritorio)
  await inicializarIntercom(vueInstance, dadosUsuario)
}

const encerrarChat = async (vueInstance) => {
  if (!chatInicializado) {
    console.log('Chat do Intercom não pode ser encerrado pois não está inicializado')
    return
  }

  if (!vueInstance?.$intercom) {
    console.log('Intercom não está inicializado ou $intercom não está disponível.')
    return
  }

  try {
    await vueInstance.$intercom.shutdown()
    restaurarDadosDefault()
    console.log('Chat do Intercom encerrado')
  } catch (erro) {
    console.error('Erro ao encerrar o Intercom:', erro)
  }
}

const atualizarChat = async (vueInstance, nome = null, email = null, dataCriacao = null, idUsuario = null, idEscritorio = null, nomeEscritorio = null) => {
  if (!chatInicializado) {
    await iniciarChat(vueInstance, nome, email, dataCriacao, idUsuario, idEscritorio, nomeEscritorio)
    return
  }

  if (ehUsuarioAnonimo(nome, email)) {
    console.log('Usuário anônimo, não há necessidade de atualizar')
    return
  }

  const dadosUsuario = montarDadosUsuario(nome, email, dataCriacao, idUsuario, idEscritorio, nomeEscritorio)
  const dadosUsuarioIguais = dadosUsuarioSaoIguais(dadosUsuario, dadosUsuarioAtuais)

  if (dadosUsuarioIguais) {
    return
  }
  await atualizarIntercom(vueInstance, dadosUsuario)
}

const inicializarIntercom = async (vueInstance, dadosUsuario = {}) => {
  if (!vueInstance?.$intercom) {
    console.log('Intercom não está disponível.')
    return
  }
  try {
    restaurarDadosDefault()
    await vueInstance.$intercom.boot(dadosUsuario)
    chatInicializado = true
    dadosUsuarioAtuais = dadosUsuario
    registrarInicializacaoIntercom(dadosUsuario)
  } catch (erro) {
    console.error('Erro ao inicializar o Intercom:', erro)
  }
}

const atualizarIntercom = async (vueInstance, dadosUsuario = {}) => {
  if (!vueInstance?.$intercom) {
    console.log('Intercom não está inicializado ou $intercom não está disponível.')
    return
  }
  try {
    await vueInstance.$intercom?.update(dadosUsuario)
    dadosUsuarioAtuais = dadosUsuario
    console.log('Chat do Intercom atualizado')
  } catch (erro) {
    console.error('Erro ao atualizar o Intercom:', erro)
  }
}

export {
  iniciarChat,
  encerrarChat,
  atualizarChat
}
